/** @format */

import React, { FunctionComponent, ReactElement, useState } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import SimCardInterface from '../../interfaces/platform/SimCardInterface';
import GridItem from '../../components/Grid/GridItem';
import Switch from '@material-ui/core/Switch';
import I18n from '../../components/Translate/I18n';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useDispatch } from 'react-redux';
import ActionButton from '../../components/Buttons/CustomTextButton';
import AlertInfo from '../../components/Info/AlertInfo';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { SimpleSelect, SimpleSelectElements } from '../../components/Adescom/SimpleSelect';
import { CycleComponentRefreshConfiguration } from '../../modules/lib/CycleComponentRefreshConfiguration';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import { AlertDialog } from '../lib/dialog/AlertDialog';

type LimitPremiumType = {
    product: SimCardInterface;
    refreshPage: () => void;
};

export const limitPremiumAmounts: Array<SimpleSelectElements> = [
    { value: 0, name: '0 PLN' },
    { value: 3500, name: '35 PLN' },
    { value: 5000, name: '50 PLN' },
    { value: 10000, name: '100 PLN' },
    { value: 20000, name: '200 PLN' },
];

export const LimitPremium: FunctionComponent<LimitPremiumType> = ({ product, refreshPage }): ReactElement => {
    const dispatch = useDispatch();
    const [limitPremiumActive, setLimitPremiumActive] = useState(product.premiumLimitEnable);
    const [limitPremiumValue, setLimitPremiumValue] = useState(product.premiumLimitValue ?? -1);
    const [saveButton, setSaveButton] = useState(false);
    const [alert, setAlert] = useState<any | null>(null);

    const onCheckBoxEvent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const name = event.target.name;
        const value = event.target.value;
        const checked = event.target.checked;
        setLimitPremiumActive(checked);
        if (product.unitLimit !== checked) {
            setSaveButton(true);
        } else {
            setSaveButton(false);
        }
    };

    const callback = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const name = event.target.name;
        const value = parseInt(event.target.value);
        const setValue = value || value === 0;
        if (setValue) {
            setSaveButton(true);
            setLimitPremiumValue(value ?? 0);
            return;
        }
        setSaveButton(false);
    };

    const activateFeatureConfirm = (): void => {
        setAlert(
            <AlertDialog
                open={alert}
                titleDialog="simcard:f.premium_limit"
                displayMessage="simcard:f.confirm_change_premium_limit"
                closeCallback={(): void => setAlert(null)}
                confirmCallback={activateCallApi}
            />
        );
    };

    const activateCallApi = (): void => {
        const itemLoader = new ItemLoaders(dispatch);
        if (limitPremiumActive) {
            const cycleComponnet = new CycleComponentRefreshConfiguration();
            itemLoader.postWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_requests')),
                'mvno_block_requests_activate_limit_premium',
                {
                    mvnoBlockListName: 'OperationPremiumLimit',
                    simCardId: product.id,
                    params: JSON.stringify({
                        componentParams: [
                            { name: 'BMPClientName', value: 'MVNE' },
                            { name: 'amount', value: limitPremiumValue },
                            { name: 'balMode', value: 'ABSOLUTE' },
                        ],
                    }),
                },
                (response: any) => {
                    setAlert(null);
                    refreshPage();
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        } else {
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.postWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_requests')),
                'mvno_block_requests_deactivate_limit_premium',
                {
                    mvnoBlockListName: 'OperationPremiumLimitDeactivate',
                    simCardId: product.id,
                    params: JSON.stringify({
                        componentParams: [
                            { name: 'BMPClientName', value: 'MVNE' },
                            { name: 'amount', value: 0 },
                            { name: 'balMode', value: 'ABSOLUTE' },
                        ],
                    }),
                },
                (response: any) => {
                    setAlert(null);
                    refreshPage();
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    };
    return (
        <GridContainer>
            <GridItem xs={12}>
                <FormControlLabel
                    disabled={UserRoleHelper.checkRole(roles.ROLE_SUBSCRIPTION_VIEW_ONLY)}
                    control={<Switch checked={limitPremiumActive} onChange={onCheckBoxEvent} value="premiumLimitSingleSwitch" />}
                    label={<I18n trans="simcard:f.premium_limit" />}
                />
            </GridItem>
            {limitPremiumActive && (
                <GridItem xs={12}>
                    <SimpleSelect
                        disabled={UserRoleHelper.checkRole(roles.ROLE_SUBSCRIPTION_VIEW_ONLY)}
                        label={'simcard:f.amount_limit_premium'}
                        required={true}
                        elements={limitPremiumAmounts}
                        selectedValue={limitPremiumValue}
                        dispatchName={'no-name'}
                        callback={callback}
                        fieldName="limitPremiumValue"
                    />
                </GridItem>
            )}
            {saveButton && !UserRoleHelper.checkRole(roles.ROLE_SUBSCRIPTION_VIEW_ONLY) && (
                <GridItem xs={12}>
                    <ActionButton callback={activateFeatureConfirm} callbackParam={{}} label="simcard:f.save_premium_limit" size="sm" />
                    {alert}
                </GridItem>
            )}
        </GridContainer>
    );
};
